class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

    const closeButton = this.querySelector('button.close-cart-drawer');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.close();
      });
    }

    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    this.variantId = this.dataset.variantId;               // id de variante asociada a este quantity-input

    //Este refresh es el que actualiza el cart cuando hay algun cambio
    document.addEventListener('cart:refresh', (event) => this.updateCart(event.detail?.variantId));

    this.addEventListener('pb:quantity:updated', this.updateLineItems.bind(this));
  }

  // Envía la actualización de cantidad al endpoint nativo de Shopify
  async updateLineItems(event){
    const { quantity, variantId, lineIndex, productTitle, message } = event.detail;

    try {
      this.lockButtons();                                  // bloquea los botones del drawer mientras se procesa

      const body = JSON.stringify({
        line: lineIndex,                                   // línea que se actualiza en el carrito
        quantity: quantity                                 // nueva cantidad deseada
      });
      
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      });
      
      if (!response.ok) {
        // Si la API de Shopify responde con error, lo propagamos
        throw new Error(`error cart: ${response.status}`);
      }
      
      window.showToast(`${message}: ${productTitle}`);

    } catch (error) {
      this.unlockButtons();
      console.error(`Error at line ${lineIndex} from cart:`, error);
      window.showToast(`${window.globalTranslations.errorAddToCart}: ${productTitle}`, 'error');
    } finally {  
      // Avisamos al resto de componentes (cards, etc.) para que se sincronicen con el cart
      this.updateCart(variantId);
    }
  }

  // Bloquea botones del drawer para evitar múltiples peticiones mientras se actualiza el cart
  lockButtons() {
    document.querySelector('#CartDrawer-Form')?.classList.add('in-request')
    this.querySelectorAll('button').forEach(button => {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
    });
  }

  
  // Desbloqueo manual de botones solo en caso de error
  // (después de una petición correcta el drawer se vuelve a renderizar y se desbloquea solo)
  unlockButtons() {
    document.querySelector('#CartDrawer-Form')?.classList.remove('in-request')
    this.querySelectorAll('button').forEach(button => {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
    });
  }

  updateCart(variantId = null) {
   

    console.log(
      "%c⚠️ AVISO: Este mensaje debería mostrarse solo una vez. Si aparece múltiples veces en un renderizado es que se está renderizando más de lo esperado y podría generar parpadeos o inconsistencias visuales.",
      "color: #fff; background: #d9534f; padding: 4px 8px; font-size: 12px; font-weight: bold; border-radius: 4px;"
    );

    document.dispatchEvent(new CustomEvent('pb:cart:refresh', {
      detail: {
        variantId,
      }
    }));

      
    fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`)
      .then(response => response.json())
      .then(sections => {
        const state = {
          sections: sections,
          id: this.productId
        };
        this.renderContents(state, false);
    });
    
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, openDrawer = true) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

      const closeButton = this.querySelector('button.close-cart-drawer');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.close();
        });
      }
      //if (openDrawer) this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.drawer__cart-items',
      },
      {
        id: 'cart-icon-bubble',
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


